import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Homan.css";

export default function HomamFilter() {
  const [homams, setHomams] = useState([]);
  const [categories, setCategories] = useState(["All Homams/Havans"]);
  const [selectedCategory, setSelectedCategory] = useState("All Homams/Havans");
  const [sortOrder, setSortOrder] = useState("low");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [modalHomam, setModalHomam] = useState(null);
  const [extraFields, setExtraFields] = useState([
    { name: "", dob: "", star: "", rashi: "", gotram: "" },
  ]);

  const itemsPerPage = 8;

  // Fetch homams and generate dynamic categories
  useEffect(() => {
    fetch("https://dashboard.jyotirvani.com/api/pujolist")
      .then((res) => res.json())
      .then((data) => {
        if (data.status && Array.isArray(data.data)) {
          setHomams(data.data);

          const uniqueCategories = Array.from(
            new Set(data.data.map((item) => item.category))
          );
          setCategories(["All Homams/Havans", ...uniqueCategories]);
        } else {
          console.error("Invalid API response:", data);
        }
      })
      .catch((err) => console.error("Fetch failed:", err));
  }, []);

  // Filtering
  const filteredHomams = homams.filter((item) => {
    return (
      (selectedCategory === "All Homams/Havans" ||
        item.category === selectedCategory) &&
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  // Sorting
  const sortedHomams = [...filteredHomams].sort((a, b) => {
    if (sortOrder === "low") return a.title.localeCompare(b.title);
    else return b.title.localeCompare(a.title);
  });

  // Pagination
  const paginatedHomams = sortedHomams.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(sortedHomams.length / itemsPerPage);

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const handleFieldChange = (index, field, value) => {
    const updatedFields = [...extraFields];
    updatedFields[index][field] = value;
    setExtraFields(updatedFields);
  };

  return (
    <div className="ra-main-homan-part">
      <div className="container">
        <div className="ra-main-homan">
          <h1 className="homam-title">ALL PUJA/HAVANS</h1>

          {/* Filters */}
          <div className="homam-filters">
            <input
              type="text"
              placeholder="Search homams..."
              className="homam-select"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <select
              className="homam-select"
              onChange={(e) => setSelectedCategory(e.target.value)}
              value={selectedCategory}
            >
              {categories.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>

            <select
              className="homam-select"
              onChange={(e) => setSortOrder(e.target.value)}
              value={sortOrder}
            >
              <option value="low">A-Z</option>
              <option value="high">Z-A</option>
            </select>

            <button onClick={handleClearSearch} className="homam-button">
              Clear
            </button>
          </div>

          {/* Cards */}
          <div className="homam-list">
            {paginatedHomams.map((homam, index) => (
              <div key={index} className="homam-card">
                <img
                  src={`https://dashboard.jyotirvani.com/uploads/pujobanner/${homam.image}`}
                  alt={homam.title}
                  className="homam-image"
                />
                <div className="homam-content">
                  <h3 className="homam-heading">{homam.title}</h3>
                  <p className="homam-category">
                    Puja/Havan for {homam.category}
                  </p>
                  <p className="homam-price">₹ {homam.price}</p>
                  <div className="homam-actions">
                    <Link to={`/puja-detail/${homam.id}`}>
                      <button className="homam-button">VIEW</button>
                    </Link>
                    <Link to={`/puja-detail/${homam.id}`}>
                    <button
                      className="homam-button"
                      // onClick={() => setModalHomam(homam)}
                    >
                      BOOK
                    </button>
                     </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="homam-pagination">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={`homam-page-btn ${
                  currentPage === i + 1 ? "active" : ""
                }`}
              >
                {i + 1}
              </button>
            ))}
          </div>

          {/* Booking Modal */}
          {modalHomam && (
            <div className="homam-modal-overlay">
              <div className="ra-db-homam-modal">
                <h2 className="ra-db-modal-title">ADD PUJA INTO CART</h2>
                <input
                  type="date"
                  className="homam-select mb-2 w-full"
                  defaultValue={new Date().toISOString().split("T")[0]}
                />
                <p className="modal-subtext">(All fields are optional)</p>

                {extraFields.map((field, idx) => (
                  <div key={idx} className="modal-field-group">
                    <div className="ra-db-row">
                      <input
                        type="text"
                        placeholder="Name"
                        className="homam-select"
                        value={field.name}
                        onChange={(e) =>
                          handleFieldChange(idx, "name", e.target.value)
                        }
                      />
                      <input
                        type="date"
                        className="homam-select"
                        value={field.dob}
                        onChange={(e) =>
                          handleFieldChange(idx, "dob", e.target.value)
                        }
                      />
                      <input
                        type="text"
                        placeholder="Father Name"
                        className="homam-select"
                        value={field.star}
                        onChange={(e) =>
                          handleFieldChange(idx, "star", e.target.value)
                        }
                      />
                      <input
                        type="text"
                        placeholder="Gotram"
                        className="homam-select"
                        value={field.gotram}
                        onChange={(e) =>
                          handleFieldChange(idx, "gotram", e.target.value)
                        }
                      />
                    </div>
                  </div>
                ))}

                <div className="ra-db-button">
                  <button
                    onClick={() => setModalHomam(null)}
                    className="modal-cancel"
                  >
                    Cancel
                  </button>
                  <button className="modal-confirm">Confirm</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
